import * as React from 'react';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/report';
import { Tournament } from '../../../../../../models/tournament';
import { TournamentReportOptionsForm } from '../TournamentReportOptionsForm';
interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
  tournament: Tournament;
}
export function TournamentTeamMembersReportForm(props: Props) {
  return (
    <TournamentReportOptionsForm
      {...props}
      reportType={REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TOURNAMENT_TEAM_MEMBERS}
      description="View school team entries and the students added to tournament teams and events."
      options={[
        {
          field: 'isShowBlank',
          label: 'Show empty teams',
          hint: 'Include teams that do not yet have members.',
          initialValue: true
        },
        {
          field: 'isHighlightNoAge',
          label: 'Highlight students without DOB',
          hint: 'Highlight students whose date of birth is missing.',
          initialValue: true
        }
      ]}
    />
  );
}
